import React, { useEffect, useState } from 'react'
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'

import { TemplatePayment } from '../../../types.ts'
import { Dialog, InfoBox, useSnackbarContext } from '../../../components'
import { useMutateDeleteTemplate } from '../../../services'

export const DeleteTemplateButton = ({
  id,
  paymentInfoShort,
  paymentCountLimit,
}: TemplatePayment): React.ReactElement => {
  const { addSnack } = useSnackbarContext()
  const qc = useQueryClient()

  const [showWarningDialog, setShowWarningDialog] = useState(false)
  const handleTogglePopup = (visible: boolean) => () => setShowWarningDialog(visible)
  const { mutate, isPending, status, reset } = useMutateDeleteTemplate(id)

  useEffect(() => {
    switch (status) {
      case 'success': {
        qc.invalidateQueries({ queryKey: ['templates_list'] })
        setShowWarningDialog(false)
        reset()
        break
      }

      case 'error': {
        addSnack({
          message: 'Произошла непредвиденная ошибка, попробуйте ещё раз',
          severity: 'error',
          timeout: 3000,
          closeIcon: false,
        })
        reset()
        break
      }
      default:
        break
    }
  }, [status])

  return (
    <Box
      onClick={(event) => event.stopPropagation()}
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Button onClick={handleTogglePopup(true)} size="medium" color="secondary">
        Удалить
      </Button>
      {showWarningDialog && (
        <Dialog
          title="Подтвердите удаление"
          open
          maxWidth="md"
          onClose={handleTogglePopup(false)}
          actions={
            <>
              <Button fullWidth color="secondary" size="large" onClick={handleTogglePopup(false)}>
                Отмена
              </Button>
              <Button fullWidth color="primary" size="large" onClick={() => mutate()} disabled={isPending}>
                {isPending ? <CircularProgress color="inherit" size={16} /> : 'Удалить шаблон'}
              </Button>
            </>
          }
          content={
            <>
              <Typography sx={{ mb: 2 }}>Вы уверены что хотите удалить данный шаблон?</Typography>
              <InfoBox>
                <Stack rowGap={0.5}>
                  <Typography>
                    <b>ID</b>: {id}
                  </Typography>
                  <Typography>
                    <b>Название товара/услуги</b>: {paymentInfoShort}
                  </Typography>
                  <Typography>
                    <b>Лимит платежей</b>: {paymentCountLimit}
                  </Typography>
                </Stack>
              </InfoBox>
            </>
          }
        />
      )}
    </Box>
  )
}
